@if (isOpen) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="onModalClick($event)">
      @if (title) {
        <div class="modal-header">
          <h2 class="modal-title">{{ title }}</h2>
          <button
            class="close-button"
            (click)="onClose()"
            [attr.aria-label]="'web.closeModal' | translate">
            &times;
          </button>
        </div>
      }
      <div class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
